export default 'spdy'
